export default allTags => tag =>
  allTags.filter(_tag => _tag.includes(tag))
